"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBurgerMenu = exports.burgerMenuContextDefaultValue = exports.burgerMenuContext = exports.BurgerMenuProvider = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _react = require("react");
var _api = require("../../api");
var _constants = require("../../constants");
var _useIsMobile = require("../../hooks/useIsMobile");
var _net = require("../../models/graphql-types/net");
var _activeMenuContext = require("./activeMenuContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
// istanbul ignore file -- api

const burgerMenuContextDefaultValue = exports.burgerMenuContextDefaultValue = {
  aboutItems: [],
  loadingAboutItems: false,
  inspirationItems: [],
  loadingInspirationItems: false,
  shopSectionItems: [],
  loadingShopSectionItems: false
};
const burgerMenuContext = exports.burgerMenuContext = /*#__PURE__*/(0, _react.createContext)(burgerMenuContextDefaultValue);
const BurgerMenuProvider = ({
  children
}) => {
  const {
    activeMenu
  } = (0, _activeMenuContext.useActiveMenu)();
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const isMenuActive = activeMenu === ToggleMenuFlyout.MenuTypes.BurgerMenu || isMobile && activeMenu === ToggleMenuFlyout.MenuTypes.AccountSideMenu || _constants.TopAreaNavigationMenus.includes(activeMenu);
  const {
    data: aboutItems,
    loading: loadingAboutItems
  } = (0, _api.useGetNavigationType)({
    type: _net.NavigationType.AboutTiles,
    enabled: isMenuActive
  });
  const {
    data: inspirationItems,
    loading: loadingInspirationItems
  } = (0, _api.useGetNavigationType)({
    type: _net.NavigationType.InspirationTiles,
    enabled: isMenuActive
  });
  const {
    data: shopSectionItems,
    loading: loadingShopSectionItems
  } = (0, _api.useGetNavigationType)({
    type: _net.NavigationType.ShopSection,
    enabled: isMenuActive
  });
  const contextValue = (0, _react.useMemo)(() => ({
    aboutItems,
    loadingAboutItems,
    inspirationItems,
    loadingInspirationItems,
    shopSectionItems,
    loadingShopSectionItems
  }), [aboutItems, loadingAboutItems, inspirationItems, loadingInspirationItems, shopSectionItems, loadingShopSectionItems]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(burgerMenuContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.BurgerMenuProvider = BurgerMenuProvider;
const useBurgerMenu = () => (0, _react.useContext)(burgerMenuContext);
exports.useBurgerMenu = useBurgerMenu;